import { http, HttpResponse } from "msw"
import type { ApiFinancialDataHealthMissions } from "../../healthMissions"
import { healthMissionsMock } from "./healthMissions.mock"

const API_DOMAIN = import.meta.env.VITE_API_DOMAIN

export const financialDataHealthMissionsHandlers = [
  // ADH
  http.get(
    `${API_DOMAIN}/api/financial-data/adherent/healthcare-missions/categories`,
    () => HttpResponse.json<ApiFinancialDataHealthMissions>(healthMissionsMock()),
  ),
  // ADMIN
  http.get(
    `${API_DOMAIN}/api/financial-data/pharmacies/:pharmacyId/healthcare-missions/categories`,
    () => HttpResponse.json<ApiFinancialDataHealthMissions>(healthMissionsMock()),
  ),
]
